module.exports = __webpack_public_path__ + "static/media/kailas.64f8444d.jpeg";